import React from 'react';
import DataGrid, { Scrolling, LoadPanel,Column,Button,Editing, Selection,FilterRow,Paging,Pager,Export,ColumnChooser, HeaderFilter, SearchPanel } from 'devextreme-react/data-grid';
import SelectBox from 'devextreme-react/select-box';
import CheckBox from 'devextreme-react/check-box';
import { Link,Redirect } from "react-router-dom";

import { Menu, Dropdown } from 'antd';



const saleAmountEditorOptions = { format: 'currency', showClearButton: true };
const allowedPageSizes = [10,25,50,100];

class Filter extends React.Component  {
  constructor(props) {
    super(props);
    this.applyFilterTypes = [{
      key: 'auto',
      name: 'Immediately'
    }, {
      key: 'onClick',
      name: 'On Button Click'
    }];
    this.state = {
	  displayMode: 'full',
      showPageSizeSelector: true,
      showInfo: true,
      showNavButtons: true,
	  showAction:false,
      showFilterRow: true,
      showHeaderFilter: true,
      currentFilter: this.applyFilterTypes[0].key
    };
    this.dataGrid = null;
    this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
    this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
    this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
    this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
  }

  
	Status(cellData) {
	  return (
		<>
			{(() => {
					if(cellData.value=='Absent') {
						return (
							<>
								<div class="chip chip-red">
									<div class="chip-body">
										<span class="chip-text">Absent</span>
									</div>
								</div>
								
							</>
						)
					}
					else{
						return (
							<>
								<div class="chip chip-green">
									<div class="chip-body">
										<span class="chip-text">Present</span>
									</div>
								</div>
							</>
						)
					}
				})()}
		</>
	  );
	}
	

  render() {
	const { data } = this.props;
    return (
      <div class="dx-viewport">
        <DataGrid id="gridContainer"
		  height={600}
          ref={(ref) => this.dataGrid = ref}
          dataSource={data}
          keyExpr="id"
		  allowColumnReordering={true}
          allowColumnResizing={true}
          columnAutoWidth={true}
          showBorders={true}
		  rowAlternationEnabled={true}
		  onSelectionChanged={this.props.onSelectionChanged}
		  >
          <FilterRow visible={this.state.showFilterRow} applyFilter={this.state.currentFilter} />
          <HeaderFilter visible={this.state.showHeaderFilter} fixed={true}  />
		  <Export enabled={true} allowExportSelectedData={true} />
		  <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            allowedPageSizes={allowedPageSizes}
            displayMode={this.state.displayMode}
            showPageSizeSelector={this.state.showPageSizeSelector}
            showInfo={this.state.showInfo}
            showNavigationButtons={this.state.showNavButtons} />

		   <Column fixed={true} dataField="name" caption="Child Name" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
		  <Column dataField="class" caption="Class" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
          <Column dataField="stop_name" caption="Stop Name" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
          <Column dataField="route_name" caption="Route" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
          <Column dataField="tag" caption="Route Type" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  <Column dataField="type" caption="Action" alignment="center" cellRender={this.Status}>
            <HeaderFilter allowSearch={true} />
          </Column>
          <Column dataField="pick_time" caption="Time" alignment="left">
			<HeaderFilter allowSearch={true} />
		  </Column>
		  
        </DataGrid>
      </div>
    );
  }
  calculateFilterExpression(value, selectedFilterOperations, target) {
    let column = this;
    if (target === 'headerFilter' && value === 'weekends') {
      return [[getOrderDay, '=', 0], 'or', [getOrderDay, '=', 6]];
    }
    return column.defaultCalculateFilterExpression.apply(this, arguments);
  }
  orderHeaderFilter(data) {
    data.dataSource.postProcess = (results) => {
      results.push({
        text: 'Weekends',
        value: 'weekends'
      });
      return results;
    };
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }
  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }
}

function getOrderDay(rowData) {
  return (new Date(rowData.OrderDate)).getDay();
}

export default Filter;
